module.exports = __webpack_public_path__ + "03fa0fb46f93a7cd5fbac457f20228e2.woff";